import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import ClusterLinksSection from './components/ClusterLinksSection';
import WhatAreManagerialNegotiations from './components/WhatAreManagerialNegotiations';
import NegotiationSituations from './components/NegotiationSituations';
import NegotiationSkills from './components/NegotiationSkills';
import ToughNegotiations from './components/ToughNegotiations';
import ManagerMistakes from './components/ManagerMistakes';
import PowerAndNegotiation from './components/PowerAndNegotiation';
import HowPracticeGoes from './components/HowPracticeGoes';
import WhyProgramsWork from './components/WhyProgramsWork';
import CompanyResults from './components/CompanyResults';
import SuitableFor from './components/SuitableFor';
import FormatsSection from './components/FormatsSection';
import HowProgramGoes from './components/HowProgramGoes';
import AboutTrainer from './components/AboutTrainer';
import FAQSection from './components/FAQSection';
import ReadNextSection from './components/ReadNextSection';
import FinalCTA from './components/FinalCTA';
import Footer from '@/components/feature/Footer';

const navLinks = [
  { label: 'Навыки', target: 'skills' },
  { label: 'Программа', target: 'process' },
  { label: 'Результаты', target: 'results' },
  { label: 'FAQ', target: 'faq' },
];

export default function ManagerialNegotiationsPage() {
  return (
    <>
      
      <SeoTitle title="Управленческие переговоры | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={navLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <ClusterLinksSection />
        <WhatAreManagerialNegotiations />
        <NegotiationSituations />

        <div id="skills">
          <NegotiationSkills />
        </div>

        <ToughNegotiations />
        <ManagerMistakes />
        <PowerAndNegotiation />
        <HowPracticeGoes />
        <WhyProgramsWork />

        <div id="results">
          <CompanyResults />
        </div>

        <SuitableFor />
        <FormatsSection />

        <div id="process">
          <HowProgramGoes />
        </div>

        <AboutTrainer />
        <FAQSection />
        <ReadNextSection />
        <FinalCTA />
        <Footer />
      </div>
    </>
  );
}